import PropTypes from "prop-types";

export default {
  id: PropTypes.string,
  type: PropTypes.string,
  thumbnail: PropTypes.string,
};
